import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getApiLanguage } from "src/services/commonLanguageHeader";
import {
  getRouteSettingByVehicleId,
  saveRouteSettingByVehicleId,
  type RouteSettingPayload,
} from "src/services/routeSettingsService";
import { useGeneralRefetchOverride } from "./general.queries";
import { QueryNames } from "./queries.constant";

type QueryOptions = { enabled?: boolean } & Record<string, unknown>;

export const useQueryGetRouteSettingByVehicleId = (
  vehicleId?: string | number,
  options: QueryOptions = {}
) => {
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);
  const enabled = !!vehicleId && options.enabled !== false;

  return useGeneralRefetchOverride(
    useQuery({
      queryKey: [...QueryNames.routeSettings, vehicleId, language],
      queryFn: () => getRouteSettingByVehicleId(vehicleId as string | number, language),
      enabled,
      retry: false,
      ...options,
    }),
    enabled
  );
};

export const useMutationSaveRouteSetting = () => {
  const queryClient = useQueryClient();
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);

  return useMutation({
    mutationFn: (payload: RouteSettingPayload) => saveRouteSettingByVehicleId(payload, language),
    onSuccess: (_data, payload) => {
      return queryClient.invalidateQueries({
        queryKey: [...QueryNames.routeSettings, payload.vehicleId, language],
        exact: true,
      });
    },
  });
};
